var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestoreGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68612 13.9663C8.72377 13.8641 9.71793 13.5323 10.6001 13.0033V14H12.0001V10.5H12H10.6001H8.5V11.9H9.81664C9.12708 12.2964 8.35664 12.5456 7.55398 12.6246C6.25269 12.7528 4.94722 12.4258 3.86 11.6994C2.77279 10.9729 1.97109 9.89194 1.59152 8.64066C1.21195 7.38938 1.27798 6.04519 1.77837 4.83714C2.27876 3.62909 3.18255 2.63192 4.33574 2.01553C5.48892 1.39913 6.82016 1.20166 8.10262 1.45676C9.38508 1.71186 10.5394 2.40374 11.3689 3.41451C12.1985 4.42529 12.6519 5.69242 12.6519 7.00001L14 7.00001C14 5.38052 13.4385 3.81114 12.4111 2.55926C11.3837 1.30738 9.954 0.45046 8.36563 0.134514C6.77726 -0.181432 5.12848 0.0631417 3.70022 0.826563C2.27196 1.58998 1.1526 2.82502 0.532845 4.32123C-0.0869059 5.81744 -0.168693 7.48225 0.30142 9.03201C0.771532 10.5818 1.76446 11.9206 3.11101 12.8203C4.45756 13.72 6.07443 14.125 7.68612 13.9663ZM6.30005 2.69995H7.70005V6.29995H10.3V7.69995H7.70005H6.30005V6.29995V2.69995Z",
    fill: "rgba(79, 95, 114, 0.32)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreGrey);
export default __webpack_public_path__ + "static/media/restore_grey.7b894bf6.svg";
export { ForwardRef as ReactComponent };